import { ROUND_END_RECORDING_TAIL_MS } from "../constants";

/** Formats a millisecond duration as "MM:SS". */
export function formatTime(totalMs: number): string {
  const seconds = Math.max(0, Math.floor(totalMs / 1000));
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
}

export interface TimerSnapshot {
  /** Round length in seconds; 0 = no time limit. */
  roundDurationSec: number;
  /** Elapsed workout time in milliseconds. */
  elapsedMs: number;
  /** The round clock has hit zero and the recording tail is running. */
  roundEnded: boolean;
}

/**
 * Computes the HUD timer label and whether the clock is running low. Shared by
 * the on-screen HUD and the canvas capture so the recorded clip matches what
 * the user sees.
 */
export function getTimerLabel(input: TimerSnapshot): { label: string; low: boolean } {
  const { roundDurationSec, elapsedMs, roundEnded } = input;
  const remainingMs = Math.max(0, roundDurationSec * 1000 - elapsedMs);
  const tailRemainingMs =
    roundDurationSec > 0 && roundEnded
      ? Math.max(0, ROUND_END_RECORDING_TAIL_MS - (elapsedMs - roundDurationSec * 1000))
      : null;
  const label =
    tailRemainingMs !== null
      ? `+${formatTime(tailRemainingMs)}`
      : roundDurationSec > 0
        ? formatTime(remainingMs)
        : formatTime(elapsedMs);
  const low = roundDurationSec > 0 && (remainingMs <= 10_000 || tailRemainingMs !== null);
  return { label, low };
}
